module.exports = __webpack_public_path__ + "media/images/front/programs/icon-arrow-right-for-category-ae13fa98367db897212e53fb923daaa1.svg";